<template lang="pug">
    div(width="200px;")
        input#payment-method-control.control-input(
            ref="controlInput"
            @keydown="controlSelector($event)"
            @keydown.enter="select()"
            @focus="_active = true"
            @blur="_active = false"
            )
        .type-selector
            v-btn(
                block
                v-for="(type, idx) in _types"
                :key="idx"
                :flat="idx !== activeKey"
                :color="idx === activeKey ? colors.secondary : ''"
                :dark="idx === activeKey"
                @click="handleClick(idx)"
            )
                span [{{type.id}}] {{type.text}}
</template>

<script>
// -- Component Imports --
// -- JS Data files import --
// -- JS Libraries Import --
// -- Mixins imports --
// -- Vuex Imports --
// -- Other Imports --
export default {
    name: 'payment-type-selector',
    props: {
        // ------------------------- UI State ---------------------------------
        /**
         * @description
         */
        active: {
            type: Boolean,
            default: () => false
        },
        // ------------------------- Component Data ---------------------------
        /**
         * @description
         */
        types: {
            type: Array,
            default: () => [],
        },
    },
    data: function() {
        return {
            // ------------------------ UI State ------------------------------
            activeKey: 0,
            // ------------------------ Data storing --------------------------
        }
    },
    computed: {
        // -------------------- Editable props binding-------------------------
        /**
         * @description
         */
        _types: {
            get: function() {
                return this.types
            },
            set: function(val) {
                this.$emit('types:change', val)
            },
        },
        /**
         * @description
         */
        _active: {
            get: function(){
                return this.active
            },
            set: function(val){
                this.$emit('active', val)
            },
        },
        // -------------------- Alias settings --------------------------------
        // -------------------- Dynamic UI State ------------------------------
        // -------------------- Displayed data --------------------------------
        // -------------------- Methods data ----------------------------------
        // -------------------- Vuex mappings ---------------------------------
    },
    methods: {
        // -------------------- UI Modification -------------------------------
        controlSelector(e) {
            switch (e.keyCode) {
                case 39:
                    if (this.activeKey < this._types.length - 1)
                        this.activeKey++
                    return
                    break
                case 37:
                    if (this.activeKey > 0) this.activeKey--
                    return
                    break
                default:
                    break
            }
            if (!isNaN(e.key) && e.key >= 1 && e.key <= 9) {
                const currentVal = this.activeKey
                this.activeKey = this._types.findIndex(
                    type => type.id === parseInt(e.key)
                )
                if(this.activeKey === -1){
                    this.activeKey = currentVal
                    return
                }else{
                    this.select()
                }
            }
        },
        // -------------------- Data fetching ---------------------------------
        // -------------------- Data handling and transformations -------------
        select() {
            this.$emit('select', this._types[this.activeKey].id)
        },
        handleClick(idx){
            this.activeKey = idx
            this.select()
        },
        // -------------------- Validations and Error handling ----------------
        // -------------------- Other functions -------------------------------
        focus() {
            this.$nextTick(() => this.$refs.controlInput.focus())
        },
        // -------------------- Vuex mappings ---------------------------------
    },
    // watch: {},
    // components: {},
    // mixins: [],
    // filters: {},
    // ------------------------ Lifecycle Methods -----------------------------
    // ------------------------ End Lifecycle Methods -------------------------
}
</script>

<style lang="scss" scoped>
.type-selector {
    display: grid;
    grid-template-rows: repeat(2, auto);
    grid-template-columns: repeat(3, auto);
}
.control-input{
    opacity: 0;
    position: fixed;
    left: -200px;
}
</style>
